/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Form_Err_EmailInputs */

const en_cp_form_err_email = /** @type {(inputs: Cp_Form_Err_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter a valid email address.`)
};

const id_cp_form_err_email = /** @type {(inputs: Cp_Form_Err_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Masukkan alamat email yang valid.`)
};

/**
* | output |
* | --- |
* | "Enter a valid email address." |
*
* @param {Cp_Form_Err_EmailInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_form_err_email = /** @type {((inputs?: Cp_Form_Err_EmailInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Form_Err_EmailInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_form_err_email(inputs)
	return en_cp_form_err_email(inputs)
});